import { DragIcon, StyledDialog, Switch } from '@room-match/shared-ui-components';
import { useState } from 'react';
import { ICategory } from 'shared/interfaces/ITalent';
import AddCreditModal from './AddCreditModal';
import { ResumeItemCont, InfoCont, ResumeItemName, ResumeItemCredit, ItemAddCreditButton } from './Resume.styles';

interface Props {
  last: boolean;
  item: ICategory;
  isActive?: boolean;
  handleToggle: (section: ICategory, isActive: boolean) => void;
  allowToggle?: boolean;
}

function ResumeItem({ item, handleToggle, isActive, last, allowToggle }: Props) {
  const { category: name, credits } = item;
  const [check, setcheck] = useState(isActive);
  const [openModal, setOpenModal] = useState(false);

  const onToggle = () => {
    if (!allowToggle) return handleToggle(item, isActive || false);
    setcheck(!check);
    setTimeout(() => {
      handleToggle(item, isActive || false);
    }, 200);
  };

  return (
    <ResumeItemCont>
      <DragIcon />
      <InfoCont>
        <ResumeItemName>{name}</ResumeItemName>
        <ResumeItemCredit isActive={isActive}>
          {credits.length} {credits.length > 1 ? ' credits' : ' credit'}
        </ResumeItemCredit>
      </InfoCont>
      {/* {isActive && (
        <ItemAddCreditButton onClick={() => setOpenModal(true)} disabled>
          ADD CREDIT
        </ItemAddCreditButton>
      )} */}
      <Switch checked={check} disabled={last} toggle={onToggle} />
      {openModal && (
        <StyledDialog
          open={openModal}
          onClose={() => setOpenModal(false)}
          maxWidth="md"
          aria-labelledby="simple-dialog-title"
        >
          <AddCreditModal item={item} onClose={() => setOpenModal(false)} />
        </StyledDialog>
      )}
    </ResumeItemCont>
  );
}

export default ResumeItem;
